import { type FormAnchorNavSection } from '@/components/form/form-anchor-nav.tsx'

export { ORDER_STATUS } from './index-list.ts'

export const FORM_SECTIONS: FormAnchorNavSection[] = [
  { id: 'order-info', title: '订单归属' },
  { id: 'service-enterprise', title: '服务对象及资料' },
  { id: 'service-items', title: '服务业务' }
]
